import { render } from "./CustomerCreateTicket.vue?vue&type=template&id=ef6ae020&scoped=true"
import script from "./CustomerCreateTicket.vue?vue&type=script&lang=js"
export * from "./CustomerCreateTicket.vue?vue&type=script&lang=js"

import "./CustomerCreateTicket.vue?vue&type=style&index=0&id=ef6ae020&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\E-TICKET\\eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef6ae020"]])

export default __exports__